import util from '../util';

export const FORMPACKS = 'FORMPACKS';
export const FORMPACK = 'FORMPACK';
export const CREATE_FORMPACK = 'CREATE_FORMPACK';
export const UPDATE_FORMPACK = 'UPDATE_FORMPACK';
export const RESET_FORMPACK = 'RESET_FORMPACK';
export const DELETE_FORMPACK = 'DELETE_FORMPACK';

export const FORMPACK_REQUEST = util.requestType(FORMPACK);
export const FORMPACK_SUCCESS = util.successType(FORMPACK);
export const FORMPACK_FAILURE = util.failureType(FORMPACK);

export const FORMPACKS_REQUEST = util.requestType(FORMPACKS);
export const FORMPACKS_SUCCESS = util.successType(FORMPACKS);
export const FORMPACKS_FAILURE = util.failureType(FORMPACKS);

export const CREATE_FORMPACK_REQUEST = util.requestType(CREATE_FORMPACK);
export const CREATE_FORMPACK_SUCCESS = util.successType(CREATE_FORMPACK);
export const CREATE_FORMPACK_FAILURE = util.failureType(CREATE_FORMPACK);

export const UPDATE_FORMPACK_REQUEST = util.requestType(UPDATE_FORMPACK);
export const UPDATE_FORMPACK_SUCCESS = util.successType(UPDATE_FORMPACK);
export const UPDATE_FORMPACK_FAILURE = util.failureType(UPDATE_FORMPACK);

export const DELETE_FORMPACK_REQUEST = util.requestType(DELETE_FORMPACK);
export const DELETE_FORMPACK_SUCCESS = util.successType(DELETE_FORMPACK);
export const DELETE_FORMPACK_FAILURE = util.failureType(DELETE_FORMPACK);
